/** Default hard minimum width for split content. */
export const DEFAULT_SPLIT_MIN_WIDTH = 400;

/** Default hard minimum height for split content stacked with other splits. */
export const DEFAULT_SPLIT_MIN_HEIGHT = 240;
